import { AxiosResponse } from "axios";
import ApiConstants from "../../../../../core/constants/api_constants";
import { request } from "../../../../../core/network/axiosInstance";


export class AuthenticationApiService {
    private readonly authBaseUrl: string;

    constructor() {
        this.authBaseUrl = ApiConstants().authentication;
    }

    async logout(): Promise<AxiosResponse> {
        const response = await request({
            method: "POST",
            url: `${this.authBaseUrl}logout`,
            requiresToken: true,
        });
        return response
    }

    async deleteAccount(): Promise<AxiosResponse> {
        const response = await request({
            method: "DELETE",
            url: `${this.authBaseUrl}`,
            requiresToken: true,
        });
        return response;
    }

    async changePassword(oldPassword: string, newPassword: string): Promise<AxiosResponse> {
        const response = await request({
            method: "POST",
            url: `${this.authBaseUrl}change-password`,
            data: JSON.stringify({ oldPassword, newPassword }),
            headers: {
                'Content-Type': 'application/json',
            },
            requiresToken: true,
        });
        return response;
    }
}